import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const MobileGestureHelper = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  if (isDismissed) return null;

  const gestures = [
    {
      id: 'tap',
      icon: 'Hand',
      title: 'Tap tiles',
      description: 'View detailed information'
    },
    {
      id: 'pull',
      icon: 'ArrowDown',
      title: 'Pull to refresh',
      description: 'Update data manually'
    },
    {
      id: 'swipe',
      icon: 'Move',
      title: 'Swipe navigation',
      description: 'Navigate between sections'
    }
  ];

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 bg-card border-2 border-primary rounded-lg shadow-2xl p-4 animate-slide-up md:hidden">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="Lightbulb" size={20} color="var(--color-primary)" />
          <span className="text-sm font-semibold text-foreground">
            Touch Gestures
          </span>
        </div>
        <button
          onClick={() => setIsDismissed(true)}
          className="text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Dismiss gesture helper"
        >
          <Icon name="X" size={18} />
        </button>
      </div>
      <div className="space-y-2">
        {gestures?.map((gesture) => (
          <div key={gesture?.id} className="flex items-center gap-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded flex items-center justify-center">
              <Icon name={gesture?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-foreground">
                {gesture?.title}
              </p>
              <p className="text-xs text-muted-foreground">
                {gesture?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileGestureHelper;